import React, { useEffect, useState } from 'react';
import { Alert, Table, Typography } from 'antd';
import { kedoGet } from './kedoApi';

const { Title, Paragraph } = Typography;

const KedoAuditPage = () => {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        (async () => {
            try {
                setRows((await kedoGet('/audit')) || []);
            } catch (e) {
                setError(e?.response?.data?.message || e.message);
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    if (error) {
        return <Alert type="error" message={error} showIcon />;
    }

    return (
        <>
            <Title level={2} style={{ fontFamily: 'Georgia, serif' }}>
                Журнал аудита
            </Title>
            <Paragraph type="secondary">
                Append-only события с хэш-цепочкой (см. prev_hash / event_hash).
            </Paragraph>
            <div className="kedo-panel">
                <Table
                    rowKey="id"
                    loading={loading}
                    size="small"
                    dataSource={rows}
                    columns={[
                        { title: 'ID', dataIndex: 'id', width: 70 },
                        { title: 'Действие', dataIndex: 'action', width: 180 },
                        { title: 'Сущность', dataIndex: 'entity_type', width: 120 },
                        { title: 'ID сущн.', dataIndex: 'entity_id', width: 90 },
                        {
                            title: 'Актор',
                            dataIndex: 'actor_user_id',
                            width: 90
                        },
                        {
                            title: 'Время',
                            dataIndex: 'created_at',
                            width: 170,
                            render: v =>
                                v ? new Date(v).toLocaleString('ru-RU') : '—'
                        },
                        {
                            title: 'Hash',
                            dataIndex: 'event_hash',
                            ellipsis: true
                        }
                    ]}
                    pagination={{ pageSize: 50 }}
                />
            </div>
        </>
    );
};

export default KedoAuditPage;
